import { render } from "./Historical_Loan_Statement.vue?vue&type=template&id=c00e50e6&scoped=true"
import script from "./Historical_Loan_Statement.vue?vue&type=script&lang=js"
export * from "./Historical_Loan_Statement.vue?vue&type=script&lang=js"

import "./Historical_Loan_Statement.vue?vue&type=style&index=0&id=c00e50e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c00e50e6"]])

export default __exports__